import './index.scss';
import React, { Fragment, useEffect, useState } from 'react';
import { Iconfont, Tooltip } from '@umu/umu-design';
import { classSet } from '@umu/umu-dom';
import { getLengthChar } from '@umu/umu-util';
import { If } from 'common/src/components';
import { getCharacterLength } from '../../../../@utils';
import { defaultWhiteOverlayInnerStyle } from '../../utils';

interface IProps {
    prefixCls?: string;
    isValid?: boolean;
    label?: string | JSX.Element;
    isForbidEditor?: boolean;
    tips?: string | string[];
    maxLength?: number;
    tooltipTitle?: string | string[];
    value: string;
    placeholder?: string;
    onChange?: (value: string) => void;
    onValidValue?: (value: string) => boolean;
}

const getTips = (info: string[] | string) => {
    const list = (Array.isArray(info) ? info : [info]).filter((_) => !!_);
    return list.length > 0 ? (
        <Fragment>
            {list.map((_, index) => {
                return <p key={`tips-div-${index}`}>{_}</p>;
            })}
        </Fragment>
    ) : (
        ''
    );
};
function LabelInput(props: IProps) {
    const [value, setValue] = useState(props.value);
    const {
        label = '',
        prefixCls = 'nav-custom-label-input',
        isValid = false,
        tips = '',
        placeholder = '',
        maxLength = 1024,
        isForbidEditor = false,
        tooltipTitle = '',
        onChange,
        onValidValue,
    } = props;
    const [isEditor, setIsEditor] = useState(false);
    useEffect(() => {
        setValue(props.value);
    }, [props.value]);
    const onInputValueChange = (value: string) => {
        let newValue = value.trim();
        newValue = maxLength && maxLength < getCharacterLength(newValue) ? getLengthChar(newValue, maxLength) : value;
        setValue(newValue);
    };
    const onBlur = () => {
        let newValue = value.trim();
        newValue = maxLength && maxLength < getCharacterLength(newValue) ? getLengthChar(newValue, maxLength) : value;
        onChange && onChange(newValue);
        setIsEditor(false);
    };
    useEffect(() => {
        if (isValid) {
            const isValidError = !!onValidValue && !onValidValue(value);
            isValidError && setIsEditor(isValidError);
        }
    }, [isValid]);
    const isValidError = isValid && !!onValidValue && !onValidValue(value);
    return (
        <div className={prefixCls}>
            <If condition={!isEditor}>
                <div className={`${prefixCls}-show-info`}>
                    <Tooltip
                        title={getTips(tooltipTitle)}
                        placement="bottom"
                        color="#ffffff"
                        zIndex={9999}
                        overlayInnerStyle={defaultWhiteOverlayInnerStyle}
                    >
                        <div className={`${prefixCls}-show-info-label`}>{label || value}</div>
                    </Tooltip>
                    <If condition={!!tips}>
                        <Tooltip
                            title={getTips(tips)}
                            placement="bottom"
                            color="#ffffff"
                            zIndex={9999}
                            overlayInnerStyle={defaultWhiteOverlayInnerStyle}
                        >
                            <Iconfont
                                className={`${prefixCls}-icon-nav ${prefixCls}-icon-nav-tips ${prefixCls}-col-split`}
                                type="Tips"
                            />
                        </Tooltip>
                    </If>
                    <If condition={!isForbidEditor}>
                        <Iconfont
                            className={`${prefixCls}-icon-nav ${prefixCls}-icon-nav-editor ${prefixCls}-col-split`}
                            type="Import"
                            onClick={() => setIsEditor(true)}
                        />
                    </If>
                </div>
            </If>
            <If condition={isEditor}>
                <input
                    className={classSet({
                        [`${prefixCls}-info`]: true,
                        [`${prefixCls}-is-error`]: isValidError,
                    })}
                    value={value}
                    autoFocus={isValid ? !isValidError : true}
                    placeholder={placeholder}
                    onChange={(e) => onInputValueChange(e.target.value)}
                    onBlur={onBlur}
                />
            </If>
        </div>
    );
}

export { LabelInput, getTips };
